

export const applyGlobalStyles = (componentStyles: string, tagName: boolean) => {
    if(!tagName) {
        const globalStyleSheet = new CSSStyleSheet();
        globalStyleSheet.replaceSync(componentStyles);
        document.adoptedStyleSheets = [
            ...document.adoptedStyleSheets,
            globalStyleSheet
        ];
        return true;
    }else{
        return false
    }
}